<template>
  <div :class="classNames">
    <div :class="classNames + '_search'">
      <div :class="classNames + '_search_con'">
        <div :class="classNames + '_search_con_item'">
          <span :class="classNames + '_search_con_item_title'">状态</span>
          <el-select
            v-model="searchObj.online_is_show"
            placeholder="请选择"
            @change="changeStatus"
          >
            <el-option
              v-for="item in selectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div :class="classNames + '_search_con_item'">
          <el-input
            placeholder="请输入课程标题"
            v-model="searchObj.title"
            class="input-with-select"
          >
          
          </el-input>
		    <el-button slot="append" type="primary" @click="search"
              >查询</el-button
            >
            <p class="common-title">提示：该列表只显示已上架且有章节的课程</p>
        </div>
      </div>
    </div>
    <div :class="classNames + '_con'">
      <div :class="classNames + '_con_table'">
        <el-table
          :data="classList"
          :header-cell-style="{ background: '#F5F7FA', color: '#454D53' }"
        >
          <!-- 	<el-table-column type="index" label="排序">
					</el-table-column> -->
          <div slot="empty">
            <img
              :src="require(`@/assets/image/${noDataName}.png`)"
              style="width: 100%; padding: 115px 0"
            />
          </div>
          <el-table-column align="center" label="排序" width="160">
            <template slot-scope="{ scope, $index }">
              <span>{{ $index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="课程" width="260">
            <template slot-scope="scope">
              <div class="course-info">
                <img :src="scope.row.list_width_img" alt="" />
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="状态" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.online_is_show == 1">显示</span>
              <span v-else>隐藏</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <span
			    @click="showdialog({id:scope.row.id,online_is_show:1})"
                v-if="scope.row.online_is_show == -1"
                :class="classNames + '_operation_title'"
                >显示</span
              >
              <span  @click="showdialog({id:scope.row.id,online_is_show:-1})" v-else :class="classNames + '_operation_title'">隐藏</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        @change="changeSize"
        :total="total_count"
        ref="pagination"
        v-model="searchObj.page"
		v-if="Math.ceil(total_count / searchObj.page_size) > 1"
      ></Pagination>
    </div>
	<el-dialog
  title="提示"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <span class="dialog-box">{{text}}</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="showHide()">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<script>
import api from "@/api/common/courseShowHide.js";
import Pagination from "@/components/pagination/pagination.vue";
// import { uploadCopyRight } from '../../mixin/uploadCopyRight.js'
// import multipleUploadImg from '@/components/upload/multiple_upload_img.vue'
export default {
  name: "courseShowHide",
  data() {
    return {
      searchObj: {
        online_is_show: 0,
        title: "",
        page: 1,
        page_size: 10,
      },
      dialogVisible:false,
      noDataName: "empty",
      classNames: "courseShowHide",
      classList: [],
	  text:'',
	  row:{},
	  total_count:0,
      selectList: [
		  {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "显示",
        },
        {
          value: -1,
          label: "隐藏",
        },
      ],
    };
  },
  created() {
    this.getClassList();
  },
  components: {
    Pagination,
  },
 

  methods: {
      handleClose(done) {
       console.log(done)
      },
    async getClassList() {
      let res = await api.courseList(this.searchObj);
      console.log(res, "-----99999999999999999999999-----",res.page_info.total_count);
      this.classList = res.list;
	  this.total_count = res.page_info.total_count
	  console.log(this.total_count,'this.total_count')
    },
    changeStatus() {
      // this.searchObj.page = 1
      // this.$refs.pagination.firstPage()
      // this.getClassLists(this.searchObj)
      // this.$refs.pagination.firstPage()
      this.noDataName = "noData";
      this.getClassLists(true);
    },
    showdialog(row) {
		if(row.online_is_show == 1){
			this.text = '确定要显示该课程吗？'
		}else{
			this.text = '确定要隐藏该课程吗？'
		}
		this.row = row;
		this.dialogVisible = true;
	},
    async showHide() {
		this.dialogVisible = false;
      let res = await api.changeStatus({
        online_is_show: this.row.online_is_show,
        id: this.row.id,
      });
	  if(res){
		  if(this.row.online_is_show == 1){
			  this.$message.success('显示成功')
		  }else{
			  this.$message.success('隐藏成功')
		  }
		  this.getClassLists();
	  }
      console.log(res,'88888888888888888');
    },
    changeSize(page) {
      this.searchObj.page = page;
      this.getClassLists();
    },
    getClassLists(flag) {
      if (flag) {
        this.searchObj.page = 1;
      }
      this.getClassList(this.searchObj);
    },
    handleBreadCrumb(path, name, id, index = 2) {
      let breadCrumbList = this.breadCrumbList.slice(0, index);
      breadCrumbList[index] = {
        title: name,
        path: id ? path + "/" + id : path,
      };
      localStorage.setItem("breadCrumbList", JSON.stringify(breadCrumbList));
      this.$router.push({
        path: id ? path + "/" + id : path,
        // query: {
        // 	// breadCrumbList: JSON.stringify(breadCrumbList),
        // 	id
        // }
      });
      breadCrumbList[index] = {
        title: name,
        path: this.$route.fullPath,
      };
    },
    search() {
      this.noDataName = "noData";
      this.getClassLists(true);
    },
  },
};
</script>
<style lang="less">
@classNames: courseShowHide;
.@{classNames} {
  .el-table::before {
    background-color: transparent;
  }
  .@{classNames}_search_btn {
    width: 70px;
    height: 40px;
    background: #1989fa;
    border-radius: 0px 2px 2px 0px;
    color: #ffffff;
    font-size: 14px;
  }
  .@{classNames}_operation_title {
    color: #1989fa;
    font-size: 14px;
    cursor: pointer;
    // &:not(:last-child) {
    // 	margin-right: 12px;
    // }
  }

  .@{classNames}_table_imgtitle_left {
    position: relative;
    margin-right: 10px;
    width: 163px;
    height: 123px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      width: 100%;
      height: 26px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .el-table__header {
    width: 100% !important;
  }
  .el-table__body {
    width: 100% !important;
  }
}
.@{classNames}_common_dialog {
  padding: 30px;
  width: 360px;
  box-sizing: border-box;
  .el-message-box__header {
    padding: 0;
  }
  .el-message-box__headerbtn {
    top: 0;
    right: 0;
  }
  .el-message-box__content {
    padding: 0;
    .el-message-box__message {
      padding-top: 12px;
      padding-bottom: 16px;
    }
  }
  .el-message-box__btns {
    .el-button {
      width: 77px;
      height: 28px;
      padding: 0;
      text-align: center;
      line-height: 28px;
    }
  }
}
.view_buy_comm {
  span {
    &:not(:first-child) {
      margin-left: 24px;
    }
    .iconfont {
      margin-right: 4px;
    }
  }
}
</style>
<style lang='less' scoped>
@classNames: courseShowHide;

.@{classNames} {
  display: flex;
  flex-direction: column;
  height: 100%;
  .@{classNames}_search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    flex-shrink: 0;

    .@{classNames}_search_con {
      display: flex;

      .@{classNames}_search_con_item {
        display: flex;
        align-items: center;
        margin-right: 16px;

        .@{classNames}_search_con_item_title {
          white-space: nowrap;
          font-size: 14px;
          color: #606266;
          margin-right: 12px;
        }
      }
    }
  }

  .@{classNames}_con {
    flex: 1;
    display: flex;
    flex-direction: column;
    /*.@{classNames}_con_table {
				flex: 1;
				height: 0;
			}*/
  }
}
.course-info {
  display: flex;
  align-items: center;
  img {
    width: 163px;
    height: 123px;
    margin-right: 10px;
  }
}
.dialog-footer{
	display: flex;
	justify-content: center;
}
.dialog-box{
	display: flex;
	justify-content: center;
}
</style>
